
import _  from '../lib/helper';
import cls  from'../lib/class';
import defaultSettings from './default-setting';
import dom from '../lib/dom';
import EventManager from '../lib/event-manager';
import guid from '../lib/guid';

var instances = {};

class Instance{

  constructor(element) {


    this.settings = _.clone(defaultSettings);
    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;

    this.isRtl = dom.css(element, 'direction') === "rtl";
    this.isNegativeScroll = (function () {
      var originalScrollLeft = element.scrollLeft;
      var result = null;
      element.scrollLeft = -1;
      result = element.scrollLeft < 0;
      element.scrollLeft = originalScrollLeft;
      return result;
    })();
    this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
    this.event = new EventManager();
    this.ownerDocument = element.ownerDocument || document;

    function focus() {
      cls.add(element, 'ps-focus');
    }

    function blur() {
      cls.remove(element, 'ps-focus');
    }

    this.scrollbarXRail = dom.appendTo(dom.e('div', 'ps-scrollbar-x-rail'), element);
    this.scrollbarX = dom.appendTo(dom.e('div', 'ps-scrollbar-x'), this.scrollbarXRail);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    this.scrollbarXBottom = _.toInt(dom.css(this.scrollbarXRail, 'bottom'));
    this.isScrollbarXUsingBottom = this.scrollbarXBottom === this.scrollbarXBottom; // !isNaN
    this.scrollbarXTop = this.isScrollbarXUsingBottom ? null : _.toInt(dom.css(this.scrollbarXRail, 'top'));
    this.railBorderXWidth = _.toInt(dom.css(this.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(this.scrollbarXRail, 'borderRightWidth'));
    // Set rail to display:block to calculate margins
    dom.css(this.scrollbarXRail, 'display', 'block');
    this.railXMarginWidth = _.toInt(dom.css(this.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(this.scrollbarXRail, 'marginRight'));
    dom.css(this.scrollbarXRail, 'display', '');
    this.railXWidth = null;
    this.railXRatio = null;

    this.scrollbarYRail = dom.appendTo(dom.e('div', 'ps-scrollbar-y-rail'), element);
    this.scrollbarY = dom.appendTo(dom.e('div', 'ps-scrollbar-y'), this.scrollbarYRail);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    this.scrollbarYRight = _.toInt(dom.css(this.scrollbarYRail, 'right'));
    this.isScrollbarYUsingRight = this.scrollbarYRight === this.scrollbarYRight; // !isNaN
    this.scrollbarYLeft = this.isScrollbarYUsingRight ? null : _.toInt(dom.css(this.scrollbarYRail, 'left'));
    this.scrollbarYOuterWidth = this.isRtl ? _.outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth = _.toInt(dom.css(this.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(this.scrollbarYRail, 'borderBottomWidth'));
    dom.css(this.scrollbarYRail, 'display', 'block');
    this.railYMarginHeight = _.toInt(dom.css(this.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(this.scrollbarYRail, 'marginBottom'));
    dom.css(this.scrollbarYRail, 'display', '');
    this.railYHeight = null;
    this.railYRatio = null;

  }

}

function getId(element) {
  return element.getAttribute('data-ps-id');
}

function setId(element, id) {
  element.setAttribute('data-ps-id', id);
}

function removeId(element) {
  element.removeAttribute('data-ps-id');
}

let exports = {};

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};

export default exports;